import React, { useState } from 'react';

const MapMarkerUpdateForm = ({ marker, onSubmit }) => {
  const [mapId, setMapId] = useState(marker?.mapId || '');
  const [title, setTitle] = useState(marker?.title || '');
  const [description, setDescription] = useState(marker?.description || '');
  const [longitude, setLongitude] = useState(marker?.location?.coordinates[0] || '');
  const [latitude, setLatitude] = useState(marker?.location?.coordinates[1] || '');
  const [status, setStatus] = useState(marker?.status || 'private');
  const [approved, setApproved] = useState(marker?.approved || false);

  const handleSubmit = (e) => {
    e.preventDefault();

    const updatedMarker = {
      mapId,
      title,
      description,
      location: {
        type: 'Point',
        coordinates: [parseFloat(longitude), parseFloat(latitude)],
      },
      status,
      approved,
    };

    onSubmit(updatedMarker);
  };

  const handleCancel = () => {
    onSubmit(null); // Pass null to signal cancellation
  };

  return (
    <form onSubmit={handleSubmit}>
      {/* <div>
        <label>Map ID:</label>
        <input
          type="text"
          value={mapId}
          onChange={(e) => setMapId(e.target.value)}
        />
      </div> */}
      <div>
        <label>Title:</label>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>
      <div>
        <label>Description:</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
      <style>{`
        textarea {
          width: calc(100% - 20px);
          padding: 15px;
          margin-top: 10px;
          border: 1px solid #ddd;
          border-radius: 6px;
          box-sizing: border-box;
          resize: vertical;
          font-family: Arial, sans-serif;
          font-size: 12px;
          min-height: 120px;
        }
        form div {
          margin-bottom: 10px;
        }
      `}</style>
      <div>
        <label>Longitude:</label>
        <input
          type="number"
          value={longitude}
          onChange={(e) => setLongitude(e.target.value)}
        />
      </div>
      <div>
        <label>Latitude:</label>
        <input
          type="number"
          value={latitude}
          onChange={(e) => setLatitude(e.target.value)}
        />
      </div>
      <div>
        <label>Status:</label>
        <select value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="public">Public</option>
          <option value="private">Private</option>
        </select>
      </div>
      {/* <div>
        <label>Approved:</label>
        <input
          type="checkbox"
          checked={approved}
          onChange={(e) => setApproved(e.target.checked)}
        />
      </div> */}
      <button type="submit">Update Marker</button>
      <button type="button" onClick={handleCancel}>Cancel</button>
    </form>
  );
};

export default MapMarkerUpdateForm;
